import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import styles from "../../../styles/components/editorDashboardTable.module.scss";
import thambnail from "../../../public/assets/images/tab_thumbnail_1.jpg";
import thambnail1 from "../../../public/assets/images/tab_thumbnail_2.jpg";
import thambnail2 from "../../../public/assets/images/tab_thumbnail_3.jpg";
import EyeTableIcon from "../../../public/assets/icons/EyeTableIcon";
import { Box, Button } from "@mui/material";
import { concatHostAndImagePath, styledDateTime } from "../../../lib/functions/utils.lib";
import VideoPageFullModal from "../../VideoPages/pages/VideoPageFullModal";
import WatchVideoModal from "../../VideoPages/pages/WatchVideoModal";

/****************table*****************/
function createData(vsid, thumbmail, title, request) {
  return { vsid, thumbmail, title, request };
}

const rows = [
  createData(
    "13194",
    <>
      <img src={thambnail} alt="" />
    </>,
    "Boy Jumped with the Umbrella and the Wind Almost Sent Him Flying Too Far Away",
    <>
      ViralSnare Admin <br /> <span className={styles.adminSpan}>Admin</span>{" "}
      <br />
      <span className={styles.timeSpan}>Aug 7, 2019 at 04:24:55 PM UTC</span>
    </>
  ),
  createData(
    "13194",
    <>
      <img src={thambnail1} alt="" />
    </>,
    "Rabbit on fence",
    <>
      Jason Marcel <br /> <span className={styles.adminSpan}>QC Agent</span>{" "}
      <br />
      <span className={styles.timeSpan}>Aug 7, 2019 at 04:24:55 PM UTC</span>
    </>
  ),
  createData(
    "13194",
    <>
      <img src={thambnail2} alt="" />
    </>,
    "Rabbit on fence",
    <>
      Micheal Monroe <br /> <span className={styles.adminSpan}>QC Agent</span>{" "}
      <br />
      <span className={styles.timeSpan}>Aug 7, 2019 at 04:24:55 PM UTC</span>
    </>
  ),
  createData(
    "13194",
    <>
      <img src={thambnail} alt="" />
    </>,
    "Boy Jumped with the Umbrella and the Wind Almost Sent Him Flying Too Far Away",
    <>
      ViralSnare Admin <br /> <span className={styles.adminSpan}>Admin</span>{" "}
      <br />
      <span className={styles.timeSpan}>Aug 7, 2019 at 04:24:55 PM UTC</span>
    </>
  ),
  createData(
    "13194",
    <>
      <img src={thambnail1} alt="" />
    </>,
    "Rabbit on fence",
    <>
      Jason Marcel <br /> <span className={styles.adminSpan}>QC Agent</span>{" "}
      <br />
      <span className={styles.timeSpan}>Aug 7, 2019 at 04:24:55 PM UTC</span>
    </>
  ),
  createData(
    "13194",
    <>
      <img src={thambnail2} alt="" />
    </>,
    "Rabbit on fence",
    <>
      Micheal Monroe <br /> <span className={styles.adminSpan}>QC Agent</span>{" "}
      <br />
      <span className={styles.timeSpan}>Aug 7, 2019 at 04:24:55 PM UTC</span>
    </>
  ),
];

const EditorDashboardTable = ({ item }) => {

  // modal design

  const [openModal, setOpenModal] = useState(false);
  const [openModalTwo, setOpenModalTwo] = useState(false);
  const [id, setId] = useState();

  const onOpen = (id) => {
    setId(id);
    setOpenModal(true);
  };
  const onClose = () => {
    setId();
    setOpenModal(false);
    handleTriggreFetch();
  };
  const onOpenTwo = (id) => {
    setId(id);
    setOpenModalTwo(true);
  };
  const onCloseTwo = () => {
    setId();
    setOpenModalTwo(false);
  };

  // modal design

  return (
    <TableContainer className={styles.tableMain}>
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell className={styles.vsid}>VSID</TableCell>
            <TableCell className={styles.thumbmail}>Thumbnail</TableCell>
            <TableCell className={styles.title}>Title</TableCell>
            <TableCell className={styles.request}>Requested by</TableCell>
            <TableCell className={styles.view} align="center">
              View
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {item.map((row) => (
            <>
              <TableRow key={row.name}>
                <TableCell className={styles.vsid}>{row.vsid}</TableCell>
                <TableCell className={styles.thumbmail}>
                  <Box className={styles.thumbImg}>
                    {" "}
                    <Button onClick={() => onOpenTwo(row.id)}>
                      <figure>
                        <img
                          // src={item.image}
                          src={concatHostAndImagePath(row?.thumbnail)}
                          alt=""
                          width={100}
                          height={62}
                        />
                      </figure>
                    </Button>
                  </Box>
                </TableCell>
                <TableCell className={styles.title}>
                  <Box className={styles.titleBox}>{row.title}</Box>
                </TableCell>
                <TableCell className={styles.request}>
                  <p>{`${row?.video_extra?.urgent_posting?.name ? row?.video_extra?.urgent_posting?.name : ""} ${row?.video_extra?.urgent_posting?.last_name}`}</p>
                  <p className={styles.adminSpan}>{row?.video_extra?.urgent_posting?.role?.display_name}</p>
                  <p className={styles.timeSpan}>{row?.video_extra?.urgent_posting_request_at ? styledDateTime(row?.video_extra?.urgent_posting_request_at) : ""}</p>
                </TableCell>
                <TableCell className={styles.view} align="center">
                  <Button>
                    <EyeTableIcon />
                  </Button>
                </TableCell>
              </TableRow>
              
              <TableRow className={styles.blnkTd}>
                <TableCell colSpan={10}>{""}</TableCell>
              </TableRow>
            </>
          ))}
        </TableBody>
      </Table>
      <VideoPageFullModal
        onClose={onClose}
        open={openModal}
        id={id}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="videoPageModal"
      />
      <WatchVideoModal
        onClose={onCloseTwo}
        open={openModalTwo}
        id={id}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="videoPageModal"
      />
    </TableContainer>
  );
};

export default EditorDashboardTable;
